module.exports = __webpack_public_path__ + "img/table-tennis-paddle-ball.26936265.svg";